import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { DEFAULT_FILTER } from './user';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';
import { Count } from '../../../models/count';
import { TournamentTeamPlayer } from '../../../models/tournamentTeamPlayer';
import { TournamentTeam } from '../../../models/tournamentTeam';

const shouldUsePost = (filter: any) => {
  try {
    const s = `filter=${encodeURIComponent(JSON.stringify(filter || {}))}`;
    if (s.length > 6000) return true;
    const inList = filter?.where?.formId?.$in || [];
    if (Array.isArray(inList) && inList.length > 200) return true;
  } catch {
    return true;
  }
  return false;
};

export function getSchoolTournamentTeam(user: AppUser, tournamentId: string, teamId: string): Promise<TournamentTeam> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .get<TournamentTeam>(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/teams/${teamId}`,
      config
    )
    .then(response => {
      return response.data;
    });
}

export function getSchoolTournamentTeamPlayers(
  user: AppUser,
  tournamentId: string,
  teamId: string,
  filter = DEFAULT_FILTER,
  includeEvents = false
): Promise<TournamentTeamPlayer[]> {
  const { roleSessionKey: key, activeSchoolId } = user;

  if (shouldUsePost(filter)) {
    return axios
      .post<TournamentTeamPlayer[]>(
        `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players/search`,
        { filter },
        { headers: { usid: key }, params: { includeEvents } }
      )
      .then(r => r.data);
  }

  return axios
    .get<TournamentTeamPlayer[]>(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players`,
      { headers: { usid: key }, params: { filter, includeEvents } }
    )
    .then(r => r.data);
}

export function getAllSchoolTournamentTeamPlayers(
  user: AppUser,
  tournamentId: string,
  teamId: string,
  where?: any
): Promise<TournamentTeamPlayer[]> {
  const filter = {
    where: { ...(where || {}) },
    limit: DEFAULT_LIMIT,
    skip: DEFAULT_SKIP
  };
  return getSchoolTournamentTeamPlayers(user, tournamentId, teamId, filter);
}

export function getSchoolTournamentTeamPlayersCount(
  user: AppUser,
  tournamentId: string,
  teamId: string,
  whereOrFilter?: any
): Promise<Count> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const filter =
    whereOrFilter?.where || whereOrFilter?.order || whereOrFilter?.limit || whereOrFilter?.skip
      ? whereOrFilter
      : { where: whereOrFilter || {} };

  if (shouldUsePost(filter)) {
    return axios
      .post<Count>(
        `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players/count/search`,
        { filter },
        { headers: { usid: key } }
      )
      .then(r => r.data);
  }

  return axios
    .get<Count>(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players/count`,
      {
        headers: { usid: key },
        params: { filter }
      }
    )
    .then(r => r.data);
}

export interface SchoolTournamentTeamPlayersBatchData {
  add?: SchoolTournamentTeamPlayerBatchData[];
  remove?: string[];
}
interface SchoolTournamentTeamPlayerBatchData {
  userId: string;
  permissionId: string;
}

export function updateSchoolTournamentTeamPlayersBatch(
  user: AppUser,
  tournamentId: string,
  teamId: string,
  data: SchoolTournamentTeamPlayersBatchData
) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key }
  };

  return axios
    .post(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/teams/${teamId}/players/batch`,
      data,
      config
    )
    .then(response => {
      return response.data;
    });
}
